import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { ApplicationInsights, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {
  private appInsights: ApplicationInsights;
  constructor(private router: Router) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: AgAppConfigService.get<string>('appinstrumentationKey'),
        enableCorsCorrelation: AgAppConfigService.get<string>('enableCorsCorrelation') === 'true',
        disableCorrelationHeaders: true
      }
    });

    this.appInsights.loadAppInsights();
    this.loadCustomTelemetryProperties();
    this.createRouterSubscription();
  }

  setUserId(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri });
  }

  logEvent(name: string, properties?: { [key: string]: string }) {
    this.appInsights.trackEvent({ name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: string }) {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  logException(error: Error) {
    const exception: IExceptionTelemetry = {
      exception: error
    };
    this.appInsights.trackException(exception);
  }

  logTrace(message: string, properties?: { [key: string]: string }) {
    this.appInsights.trackTrace({ message }, properties);
  }

  private loadCustomTelemetryProperties() {
    this.appInsights.addTelemetryInitializer(envelope => {
      const item = envelope.baseData;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      item.properties = item.properties || {};
      // eslint-disable-next-line @typescript-eslint/quotes, , , @typescript-eslint/dot-notation, @typescript-eslint/no-unsafe-member-access
      item.properties["ApplicationPlatform"] = 'WEB';
      // eslint-disable-next-line @typescript-eslint/quotes, @typescript-eslint/dot-notation, @typescript-eslint/no-unsafe-member-access
      item.properties["ApplicationName"] = AgAppConfigService.get<string>('InsightapplicationName');
    }
    );
  }

  private createRouterSubscription() {
    // this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
    //   this.logPageView(null, event.urlAfterRedirects);
    // });

    this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const activatedComponent = this.getActivatedComponent(event.state.root);
      if (activatedComponent) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }
}
